module.exports = __webpack_public_path__ + "static/media/placeholder_work.44ee4667.png";